import React, { useState } from "react";
import { X, ChevronDown } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import "./BookingModal.css";

const BookingModal = ({ isOpen, onClose, phone = "+917574098964" }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    tripType: "oneway",
    mobileNo: "",
    pickupCity: "",
    dropCity: "",
    pickDate: "",
    pickTime: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const tripTypeMap = {
      oneway: "Oneway",
      roundtrip: "Round Trip",
      local: "Local"
    };

    const message = `*New Booking Request*%0A%0A` +
      `*Full Name:* ${formData.fullName}%0A` +
      `*Trip Type:* ${tripTypeMap[formData.tripType]}%0A` +
      `*Mobile No:* ${formData.mobileNo}%0A` +
      `*Pickup City:* ${formData.pickupCity}%0A` +
      `*Drop City:* ${formData.dropCity}%0A` +
      `*Pick Date:* ${formData.pickDate}%0A` +
      `*Pick Time:* ${formData.pickTime}`;

    const whatsappNumber = phone.replace(/\s/g, "");
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
    
    setTimeout(() => {
      setIsSubmitting(false);
      onClose();
      // Reset form
      setFormData({
        fullName: "",
        tripType: "oneway",
        mobileNo: "",
        pickupCity: "",
        dropCity: "",
        pickDate: "",
        pickTime: "",
      });
    }, 1500);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={20} />
        </button>
        
        <div className="modal-header">
          <h2>Book <span>Quick Ride</span> Now</h2>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="modal-form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter Full Name"
              value={formData.fullName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="modal-form-group">
            <label>Trip Type</label>
            <div className="modal-select-wrapper">
              <select
                name="tripType"
                value={formData.tripType}
                onChange={handleInputChange}
                required
              >
                <option value="oneway">Oneway</option>
                <option value="roundtrip">Round Trip</option>
                <option value="local">Local</option>
              </select>
              <ChevronDown size={18} className="modal-select-icon" />
            </div>
          </div>

          <div className="modal-form-group">
            <label>Mobile No</label>
            <input
              type="tel"
              name="mobileNo"
              placeholder="Enter Number"
              value={formData.mobileNo}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group">
              <label>Pickup City</label>
              <input
                type="text"
                name="pickupCity"
                placeholder="Enter Pickup City"
                value={formData.pickupCity}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="modal-form-group">
              <label>Drop City</label>
              <input
                type="text"
                name="dropCity"
                placeholder="Enter Drop City"
                value={formData.dropCity}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group">
              <label>Pick Date</label>
              <input
                type="date"
                name="pickDate"
                value={formData.pickDate}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="modal-form-group">
              <label>Pick Time</label>
              <input
                type="time"
                name="pickTime"
                value={formData.pickTime}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span className="modal-spinner"></span>
            ) : (
              <>
                <FaWhatsapp className="modal-whatsapp-icon" />
                Book Cabs
              </>
            )}
          </button>

          <div className="modal-footer">
            <span className="modal-brand">Bhole Cab Service</span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookingModal;